import { NotebookDialog } from "@/modules/note-taker/notebook-dialog";
import { TasksTrigger } from "@/modules/note-taker/tasks-trigger";
import { handleError } from "@/utils/error";
import { useEvents, useUpdateEvent } from "creso-core/hooks";
import { Client } from "creso-core/types";
import { format } from "date-fns";
import { PlusIcon } from "lucide-react";
import { useMemo } from "react";
import { Button, Checkbox, cn, V2Label } from "web-design-system";

export function ClientTasks(props: { client: Client }) {
  const { data: events } = useEvents({
    date: format(new Date(), "yyyy-MM-dd"),
    clientId: props.client.id,
  });

  const { mutateAsync: updateEvent, isPending } = useUpdateEvent();

  const tasks = useMemo(
    () => events?.filter((e) => e.type === "NOTE" || e.type === "TASK"),
    [events]
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-2 items-center">
        <NotebookDialog
          trigger={(props) => <TasksTrigger {...props} label="Today's tasks" />}
          view="calendar"
          client={props.client}
        />
        <NotebookDialog
          trigger={({ onClick }) => (
            <Button
              onClick={onClick}
              size="icon"
              className="ml-auto"
              variant="outline"
            >
              <PlusIcon />
            </Button>
          )}
          action="add-task"
          view="calendar"
          client={props.client}
        />
      </div>

      <div className="px-2 flex flex-col gap-4">
        {tasks?.map((t) => (
          <div key={t.id} className="flex flex-row gap-3 items-start">
            <Checkbox
              checked={t.is_deprecated}
              disabled={isPending}
              onCheckedChange={(c) =>
                updateEvent({
                  ...t,
                  is_deprecated: !!c,
                }).catch((e) => handleError(e, "Failed to update task."))
              }
              className="mt-px"
              id={t.id?.toString()}
            />
            <V2Label
              className={cn(
                "font-normal leading-5",
                t.is_deprecated && "line-through text-muted-foreground"
              )}
              htmlFor={t.id?.toString()}
            >
              {t.note}
            </V2Label>
          </div>
        ))}
      </div>
    </div>
  );
}
